import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Tag } from '@/services/api';
import TagService from '@/services/TagService';
import { loadingStatus } from '@/utils/loadingStatus';

@Module({
	namespaced: true
})
export default class TagStore extends VuexModule {

	tags: Tag[] = [];
	loadingStatus: loadingStatus = loadingStatus.UNLOADED;
	tagService = new TagService;

	@Mutation
	setTags(tags: Tag[]): void {
		this.tags = tags;
	}

	@Mutation
	setLoadingStatus(payload: loadingStatus): void {
		this.loadingStatus = payload;
	}

	@Action({ commit: 'setTags', rawError: true })
	async fetchTags(): Promise<Tag[]> {

		if (this.loadingStatus === loadingStatus.LOADING) {
			return this.tags;
		}

		if (this.tags.length > 0) {
			return this.tags;
		}

		this.context.commit('setLoadingStatus', loadingStatus.LOADING);
		return await this.tagService.findSuggestedTags().then(resp => {
			this.context.commit('setLoadingStatus',  loadingStatus.LOADED);
			return resp.data.data || [];
		}).catch(() => {
			this.context.commit('setLoadingStatus', loadingStatus.UNLOADED);
			return [];
		});	
	}
	
}